import { render, staticRenderFns } from "./WidgetsReportEHakmilik.vue?vue&type=template&id=1165b646&scoped=true"
import script from "./WidgetsReportEHakmilik.vue?vue&type=script&lang=js"
export * from "./WidgetsReportEHakmilik.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportEHakmilik.vue?vue&type=style&index=0&id=1165b646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165b646",
  null
  
)

export default component.exports